import { InlineInput, TextAreaInlineInput } from '@ztechapps/webui.input'
import React from 'react'
import type { Invoice } from '@ztechapps/totalmilk-payme.contract'
import { queries } from './graphql'
import { useInvoiceListContext } from './Context'

export const RemarksInlineInput = (props: { invoice: Invoice }) => {
  const context = useInvoiceListContext()

  return (
    <InlineInput
      parentInputComponent={TextAreaInlineInput}
      name={'remarks'}
      initialValues={props.invoice}
      mutationConfig={queries.updateConfig}
      canEdit={context.canEdit}
    />
  )
}
